<template>
    <div class="terms-wrapper">
        <riskhub-vue-element-loading :active="loading" :is-full-screen="true" />
        <div class="terms"
             v-if="terms.length > 0"
             v-html="terms">
        </div>
    </div>
</template>

<script>
import User from '@/services/User/User';

export default {
  name: 'Terms-And-Conditions',
  components: {},
  data() {
    return {
      loading: false,
      terms: '',
    };
  },
  created() {
    this.getTerms();
  },
  methods: {
    async getTerms() {
      this.loading = true;

      const { data } = await User.getEULA();
      this.terms = data.data.terms;
      this.loading = false;
    },
  },
};
</script>
<style>
    .terms-wrapper {
        min-height: 100px;
    }
</style>
